import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1b1550d2&"
import script from "./Footer.vue?vue&type=script&defer=true&lang=js&"
export * from "./Footer.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports